import axios from 'axios'
const state = {
  rootUrl: process.env.VUE_APP_ROOT_URL
}
const getters = {}
const mutations = {}
const actions = {
  support (store, info) {
    return new Promise((resolve, reject) => {
      axios.post(`${state.rootUrl  }/api/support/`, info
      ).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
